import React, { useRef, useState } from "react";
import ProductLanguageSelectPanelComponent from "./productLanguageSelectPanel.component";
import ProductLanguageSelectComponent from "./productLanguageSelect.component";

export default function ProductLanguageSelectContainer({
  value,
  options,
  onSelect,
  disabled,
  style,
  panelStyle,
  anchorOrigin,
  transformOrigin,
  PaperProps,
  textStyle,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const anchorRef = useRef();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageClick = (language) => {
    onSelect(language);
    setAnchorEl(null);
  };

  return (
    <>
      <ProductLanguageSelectComponent
        handleClick={handleClick}
        value={value}
        style={style}
        disabled={disabled}
        anchorRef={anchorRef}
        open={open}
        textStyle={textStyle}
      />
      <ProductLanguageSelectPanelComponent
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        handleClick={handleLanguageClick}
        options={options}
        style={panelStyle}
        id={id}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        PaperProps={PaperProps}
      />
    </>
  );
}
